export const ACCENT = "#4D9FFF";

export const PH = {
  company: "Guaranteed Rate Inc. DBA Rate",
  nmls: "1443167",
  companyNmls: "2611",
  licenseStates: "NY, NJ, CT, PA & FL",
  duration: "[[45 MIN — CONFIRM]]",
  date: "OCTOBER 15, 2026 · 7:00 PM ET [[CONFIRM DATE]]",
  dateEs: "15 DE OCTUBRE, 2026 · 7:00 PM ET [[CONFIRM DATE]]",
};

export const WEBINAR_DATE_ISO = "2026-10-15T19:00:00-04:00";
export const WEBINAR_DURATION_MIN = 60;

export const COPY = {
  en: {
    nav: { learn: "LEARN", host: "HOST", faq: "FAQ", register: "REGISTER ↗" },
    eyebrow: "FREE LIVE SESSION FOR FIRST-TIME HOMEBUYERS — NY, NJ, CT, PA & FL",
    h1: ["LEARN HOW TO BUY YOUR", "FIRST HOME STRATEGICALLY —", "NOT EMOTIONALLY"],
    sub: [
      { t: "The free session that shows " }, { t: "first-time homebuyers", a: 1 },
      { t: " how to understand their loan options in " }, { t: "their own language", a: 1 },
      { t: " — before they commit to anything." },
    ],
    quote: "What if you could understand your loan options fully before you ever talk to a lender who's trying to close you?",
    cta: "✓ RESERVE MY FREE SEAT",
    ctaSub: "LOW TICKET NOTICE! — SEATS FILL FAST",
    dateLine: `📅 ${PH.date}`,
    countdown: { until: "SESSION BEGINS IN", days: "DAYS", hours: "HRS", min: "MIN", sec: "SEC" },
    thankyou: {
      tag: "SEAT RESERVED",
      title: "YOU'RE ON THE LIST.",
      body: "Your seat for The Strategic Buyer Session is confirmed. Check your email for access details — and add it to your calendar now so you don't miss it:",
      google: "＋ ADD TO GOOGLE CALENDAR",
      ics: "＋ APPLE / OUTLOOK (.ICS)",
      back: "← BACK TO THE SESSION PAGE",
    },
    hostName: "Plinio Angulo",
    card: {
      label: "DON'T MISS OUT",
      header: "When You Register, You'll Receive:",
      bonuses: [
        { t: "Free Live Strategy Session Access", ph: null },
        { t: "First-Time Buyer Loan Options Overview (Guide)", ph: null },
        { t: "Documentation Checklist for Your Loan Type", ph: null },
        { t: "Top Questions First-Time Buyers Ask, Answered", ph: null },
        { t: "Optional 1-on-1 Follow-Up Conversation With Plinio", ph: null },
      ],
      free: "FREE!",
      trust: "Free educational event · No obligation · No hard credit pull required to attend",
    },
    form: {
      firstName: "First name", lastName: "Last name", email: "Email address", phone: "Mobile phone",
      state: "Select your state", journey: "Where are you in your homebuying journey? (optional)",
      states: ["New York", "New Jersey", "Connecticut", "Pennsylvania", "Florida", "Other"],
      journeys: ["Just exploring", "Buying within 90 days", "Buying within 90–180 days", "Already looking at homes"],
      consent: "I agree to receive email and SMS communications about this event. Message and data rates may apply. Consent is not a condition of any purchase or loan. Reply STOP to unsubscribe.",
      submit: "✓ RESERVE MY FREE SEAT",
      submitting: "RESERVING...",
      errors: { required: "Please complete all required fields.", consent: "Please check the consent box to register.", server: "Something went wrong. Please try again." },
      success: { title: "YOU'RE ON THE LIST.", body: "Check your email for confirmation and session details. No obligation, no credit pull — just clarity.", tag: "SEAT RESERVED" },
    },
    ticker: [`${PH.duration}`, "5 CORE MODULES", "LIVE Q&A INCLUDED", "NY · NJ · CT · PA · FL COVERAGE", "NO COST TO ATTEND", "FHA & CONVENTIONAL FIRST-TIME BUYER SPECIALISTS"],
    manifesto: {
      label: "THE PROBLEM",
      lines: [
        { t: "BUYING YOUR FIRST HOME", c: "w" },
        { t: "SHOULD NOT FEEL", c: "m" },
        { t: "LIKE GUESSING", c: "w" },
        { t: "IN A SECOND LANGUAGE.", c: "a" },
      ],
      body: "For thousands of Spanish-speaking families, the mortgage process arrives as jargon, pressure, and fine print. This session slows it down: one hour, plain language, your questions answered before you sign anything.",
      cta: "RESERVE MY FREE SEAT",
    },
    letter: {
      label: "",
      salutation: "Hola,",
      intro: "If you've thought about buying your first home, you've probably heard some version of these:",
      beliefs: [
        "\u201CI need perfect credit before anyone will even talk to me about buying.\u201D",
        "\u201CThe mortgage process is too complicated to understand in my own language.\u201D",
        "\u201CI should just take whatever the first lender offers me instead of comparing my options.\u201D",
      ],
      revelation: "None of these have to be true. When someone finally explains the requirements clearly — step by step, in the language you think in — the \u201Ccomplicated\u201D process becomes simple. This session won't promise you an approval or a rate. It gives you something more useful: a clear map before you make any decision.",
      signoff: "— Plinio Angulo, Guaranteed Rate DBA Rate",
    },
    audience: {
      label: "",
      h2: "THIS SESSION IS DESIGNED FOR:",
      cards: [
        { i: "🏠", t: "First-Time Homebuyers Ready to Buy Within 6 Months" },
        { i: "🗣️", t: "Spanish-Speaking Buyers Who Want the Process Explained in Their Language" },
        { i: "📄", t: "Buyers With Documented, Verifiable Income" },
        { i: "💳", t: "Buyers With Credit Scores of 580 or Above" },
        { i: "❓", t: "Anyone Who Feels Like Every Lender Is Rushing Them to Decide" },
      ],
    },
    roadmap: [
      { n: "01", l: "STEP ONE", t: "RESERVE", d: "Register free in under a minute." },
      { n: "02", l: "STEP TWO", t: "WATCH", d: "Join live — five modules plus Q&A." },
      { n: "03", l: "STEP THREE", t: "PREPARE", d: "Gather exactly what your loan type requires." },
      { n: "04", l: "STEP FOUR", t: "DECIDE", d: "Take a clear next step on your timeline. Zero pressure." },
    ],
    curriculum: {
      label: "",
      h2: "GET A SNEAK PEEK INTO THE SESSION",
      meta: `5 MODULES · ${PH.duration} TOTAL`,
      modules: [
        { t: "UNDERSTAND WHERE YOU STAND", b: "A review of what \u201Cdocumented income\u201D and credit readiness actually mean for your situation." },
        { t: "KNOW WHAT TO PREPARE", b: "The documents and information first-time buyers need before applying for FHA or Conventional financing." },
        { t: "EXPLORE YOUR OPTIONS", b: "A walkthrough of FHA and Conventional program considerations for first-time buyers — explained in plain language." },
        { t: "AVOID COMMON MISSTEPS", b: "Decisions first-time buyers often make emotionally that can work against them, and how to avoid them." },
        { t: "LEAVE WITH A CLEAR NEXT STEP", b: "A personalized recap of your options and an optional next conversation — no pressure to decide on the spot." },
      ],
    },
    host: {
      label: "",
      h2: "GUIDANCE FROM SOMEONE WHO WORKS INSIDE THE PROCESS.",
      bio: [
        "I work with Spanish-speaking first-time homebuyers every day, and I hear the same thing in almost every first conversation: nobody has ever actually explained this to me.",
        "The Strategic Buyer Session is one hour of straight explanation — how FHA and Conventional options generally work for first-time buyers, what documentation matters, and which questions to ask. No promises about rates or approvals. Just the understanding you deserve before you talk to anyone about a loan.",
      ],
      creds: [
        { l: "COMPANY", v: PH.company, ph: false },
        { l: "NMLS#", v: PH.nmls, ph: false },
        { l: "CO. NMLS#", v: PH.companyNmls, ph: false },
        { l: "LICENSED IN", v: PH.licenseStates, ph: false },
      ],
    },
    empathy: {
      label: "",
      h2: "If You're Like Most First-Time Buyers I Work With...",
      pains: [
        "You've probably sat across from someone who quoted numbers you couldn't verify and asked when you'd be ready to move forward — fast, in English, full of acronyms no one defines. That's not a strategy. That's a coin flip with the biggest purchase of your life.",
      ],
      changesLabel: "HERE'S WHAT CHANGES AFTER THIS SESSION:",
      transforms: [
        "You'll understand which loan programs realistically fit your situation",
        "You'll know exactly what documentation to gather before applying",
        "You'll have a clear next step, in your own language, with no obligation to proceed",
      ],
    },
    takeaways: {
      label: "",
      h2: "WHAT YOU'LL WALK AWAY WITH",
      cards: [
        { i: "🗺️", t: "Clearer View", d: "A realistic picture of the FHA and Conventional paths available to first-time buyers." },
        { i: "✅", t: "Preparation Checklist", d: "Exactly which documents to gather so you're never scrambling when it counts." },
        { i: "💬", t: "Questions to Ask", d: "The questions that reveal whether any lender is explaining — or just selling." },
        { i: "📋", t: "Optional Next Step", d: "A no-pressure path to a 1-on-1 conversation with Plinio, only if you want it." },
      ],
      testimonialNote: "[VERIFIED TESTIMONIAL — REPLACE WITH REAL REVIEW]",
    },
    faq: {
      label: "",
      h2: "COMMON QUESTIONS",
      items: [
        { q: "Is the session free?", a: "Yes — completely free. This is an educational event for first-time homebuyers. There is no fee, no purchase, and nothing to buy at the end." },
        { q: "Is this a loan application?", a: "No. Attending is not a loan application and creates no obligation. It's an educational walkthrough of FHA and Conventional considerations for first-time buyers." },
        { q: "Will attending affect my credit?", a: "No. Registering and attending involves no credit pull of any kind — hard or soft. You're simply watching an educational session." },
        { q: "Who is this session for?", a: "First-time homebuyers — especially Spanish-speaking buyers in NY, NJ, CT, PA & FL — who want their FHA and Conventional options explained clearly before committing to anything." },
        { q: "What will be covered?", a: "Five modules: understanding where you stand, what to prepare, exploring FHA & Conventional options in plain language, avoiding common missteps, and leaving with a clear next step." },
        { q: "Is it live or on demand?", a: "It's a live session with live Q&A, so you can ask your own questions. Register and you'll receive the date, time, and access details by email." },
        { q: "What happens after I register?", a: "You'll get an email confirmation with the session details. Before the session you'll receive the preparation materials. That's it — no calls unless you request one." },
        { q: "Do I have to speak with a loan officer?", a: "No. The 1-on-1 follow-up conversation with Plinio is completely optional. You can attend, learn, and decide on your own timeline with zero obligation." },
      ],
    },
    final: {
      label: "",
      h2a: "YOUR NEXT MOVE STARTS WITH A CLEARER ",
      h2b: "MAP.",
      bullets: [
        "100% free educational session — no cost, ever",
        "No hard credit pull required to attend",
        "Explained in plain language — English & Spanish",
        "No obligation to apply, proceed, or speak to anyone",
      ],
    },
    footer: {
      contact: ["📞 +1 (973) 901-2586", "✉️ pa.group@outlook.com", "🌐 webinar.plinioangulo.com"],
      legalLinks: [{ t: "Privacy Policy", to: "/privacy" }, { t: "Terms & Conditions", to: "/terms" }],
      compliance: "[[APROBACIÓN DE CUMPLIMIENTO PENDIENTE — texto final sujeto a aprobación del brokerage]]",
      complianceDraft: "Borrador propuesto: \u201CEsta es una sesión educativa. La asistencia no constituye una solicitud de préstamo. No se requiere consulta de crédito. Los resultados no están garantizados. Plinio Angulo NMLS #1443167, Guaranteed Rate Inc. DBA Rate NMLS #2611.\u201D",
      copyright: "© 2026 Guaranteed Rate Inc. DBA Rate",
    },
  },

  es: {
    nav: { learn: "APRENDA", host: "ANFITRIÓN", faq: "PREGUNTAS", register: "REGÍSTRESE ↗" },
    eyebrow: "SESIÓN GRATUITA EN VIVO PARA COMPRADORES DE VIVIENDA POR PRIMERA VEZ — NY, NJ, CT, PA Y FL",
    h1: ["APRENDA A COMPRAR SU", "PRIMERA CASA CON ESTRATEGIA —", "NO CON EMOCIÓN"],
    sub: [
      { t: "La sesión gratuita que ayuda a los " }, { t: "compradores de vivienda por primera vez", a: 1 },
      { t: " a entender sus opciones de préstamo en " }, { t: "su propio idioma", a: 1 },
      { t: ", antes de comprometerse a nada." },
    ],
    quote: "¿Y si pudiera entender todas sus opciones de préstamo antes de hablar con un prestamista que intenta presionarlo para que tome una decisión?",
    cta: "✓ RESERVAR MI CUPO GRATIS",
    ctaSub: "¡AVISO! — LOS CUPOS SE LLENAN RÁPIDO",
    dateLine: `📅 ${PH.dateEs}`,
    countdown: { until: "LA SESIÓN COMIENZA EN", days: "DÍAS", hours: "HRS", min: "MIN", sec: "SEG" },
    thankyou: {
      tag: "CUPO RESERVADO",
      title: "¡ESTÁ EN LA LISTA!",
      body: "Su cupo para La Sesión del Comprador Estratégico está confirmado. Revise su correo para los detalles de acceso — y agréguela a su calendario ahora para no perdérsela:",
      google: "＋ AGREGAR A GOOGLE CALENDAR",
      ics: "＋ APPLE / OUTLOOK (.ICS)",
      back: "← VOLVER A LA PÁGINA DE LA SESIÓN",
    },
    hostName: "Plinio Angulo",
    card: {
      label: "NO TE LO PIERDAS",
      header: "Al registrarse, usted recibirá:",
      bonuses: [
        { t: "Acceso gratis a la sesión de estrategia en vivo", ph: null },
        { t: "Guía de opciones de préstamo para compradores de vivienda por primera vez", ph: null },
        { t: "Lista de documentos según su tipo de préstamo", ph: null },
        { t: "Respuestas a las preguntas más comunes de compradores de vivienda por primera vez", ph: null },
        { t: "Conversación 1-a-1 opcional de seguimiento con Plinio", ph: null },
      ],
      free: "¡GRATIS!",
      trust: "Evento educativo gratuito · Sin compromiso · No se requiere consulta de crédito para asistir",
    },
    form: {
      firstName: "Nombre", lastName: "Apellido", email: "Correo electrónico", phone: "Teléfono móvil",
      state: "Seleccione su estado", journey: "¿En qué etapa del proceso de compra se encuentra? (Opcional)",
      states: ["New York", "New Jersey", "Connecticut", "Pennsylvania", "Florida", "Otro"],
      journeys: ["Solo explorando", "Comprando en 90 días", "Comprando en 90–180 días", "Ya estoy viendo casas"],
      consent: "Acepto recibir comunicaciones por correo electrónico y SMS sobre este evento. Pueden aplicarse tarifas por mensajes y datos. El consentimiento no es una condición para comprar ni para obtener un préstamo. Responda STOP para cancelar.",
      submit: "✓ RESERVAR MI CUPO GRATIS",
      submitting: "RESERVANDO...",
      errors: { required: "Por favor complete todos los campos requeridos.", consent: "Marque la casilla de consentimiento para registrarse.", server: "Algo salió mal. Por favor inténtelo de nuevo." },
      success: { title: "¡ESTÁ EN LA LISTA!", body: "Revise su correo para la confirmación y los detalles de la sesión. Sin compromiso, sin consulta de crédito — solo claridad.", tag: "CUPO RESERVADO" },
    },
    ticker: [`${PH.duration}`, "5 MÓDULOS CENTRALES", "PREGUNTAS EN VIVO INCLUIDAS", "COBERTURA NY · NJ · CT · PA · FL", "SIN COSTO PARA ASISTIR", "ESPECIALISTAS EN PRÉSTAMOS FHA Y CONVENCIONALES PARA COMPRADORES DE VIVIENDA POR PRIMERA VEZ"],
    manifesto: {
      label: "EL PROBLEMA",
      lines: [
        { t: "COMPRAR SU PRIMERA CASA", c: "w" },
        { t: "NO DEBERÍA SENTIRSE", c: "m" },
        { t: "COMO ADIVINAR", c: "w" },
        { t: "EN UN SEGUNDO IDIOMA.", c: "a" },
      ],
      body: "Para miles de familias hispanohablantes, el proceso hipotecario viene lleno de tecnicismos, presión y letra pequeña. Esta sesión lo frena: una hora, lenguaje claro, sus preguntas respondidas antes de firmar nada.",
      cta: "RESERVAR MI CUPO GRATIS",
    },
    letter: {
      label: "",
      salutation: "Hola,",
      intro: "Si usted ha pensado en comprar su primera casa, probablemente ha escuchado alguna versión de esto:",
      beliefs: [
        "\u201CNecesito crédito perfecto antes de que alguien siquiera hable conmigo sobre comprar.\u201D",
        "\u201CEl proceso hipotecario es demasiado complicado para entenderlo en mi propio idioma.\u201D",
        "\u201CDebería aceptar lo que me ofrezca el primer prestamista en vez de comparar mis opciones.\u201D",
      ],
      revelation: "Nada de esto tiene que ser cierto. Cuando alguien por fin explica los requisitos con claridad — paso a paso, en el idioma en el que usted piensa — el proceso \u201Ccomplicado\u201D se vuelve simple. Esta sesión no le promete una aprobación ni una tasa. Le da algo más útil: un mapa claro antes de tomar cualquier decisión.",
      signoff: "— Plinio Angulo, Guaranteed Rate DBA Rate",
    },
    audience: {
      label: "",
      h2: "ESTA SESIÓN ESTÁ DISEÑADA PARA:",
      cards: [
        { i: "🏠", t: "Compradores de vivienda por primera vez listos para comprar en 6 meses" },
        { i: "🗣️", t: "Compradores hispanohablantes que quieren que el proceso se explique en su idioma" },
        { i: "📄", t: "Compradores con ingresos documentados y verificables" },
        { i: "💳", t: "Compradores con puntaje de crédito de 580 o más" },
        { i: "❓", t: "Cualquier persona que sienta que todos los prestamistas la presionan a decidir" },
      ],
    },
    roadmap: [
      { n: "01", l: "PASO UNO", t: "RESERVA", d: "Regístrese gratis en menos de un minuto." },
      { n: "02", l: "PASO DOS", t: "ASISTA", d: "Únase en vivo — cinco módulos y preguntas en vivo." },
      { n: "03", l: "PASO TRES", t: "PREPARE", d: "Reúna exactamente lo que su tipo de préstamo requiere." },
      { n: "04", l: "PASO CUATRO", t: "DECIDA", d: "Dé un siguiente paso claro a su ritmo. Cero presión." },
    ],
    curriculum: {
      label: "",
      h2: "UN VISTAZO AL CONTENIDO DE LA SESIÓN",
      meta: `5 MÓDULOS · ${PH.duration} TOTAL`,
      modules: [
        { t: "ENTIENDA DÓNDE ESTÁ", b: "Un repaso de lo que significan realmente los ingresos documentados y la preparación crediticia para su situación." },
        { t: "SEPA QUÉ PREPARAR", b: "Los documentos y la información que los compradores de vivienda por primera vez necesitan antes de solicitar un préstamo FHA o un préstamo convencional." },
        { t: "EXPLORE SUS OPCIONES", b: "Un recorrido por las consideraciones del préstamo FHA y el préstamo convencional para compradores de vivienda por primera vez — explicado en lenguaje sencillo." },
        { t: "EVITE ERRORES COMUNES", b: "Decisiones que los compradores de vivienda por primera vez suelen tomar por emoción y que pueden jugar en su contra, y cómo evitarlas." },
        { t: "SALGA CON UN SIGUIENTE PASO CLARO", b: "Un resumen personalizado de sus opciones y una conversación opcional — sin presión de decidir en el momento." },
      ],
    },
    host: {
      label: "",
      h2: "ORIENTACIÓN DE ALGUIEN QUE CONOCE EL PROCESO DESDE DENTRO.",
      bio: [
        "Trabajo todos los días con compradores de vivienda por primera vez que hablan español y escucho lo mismo en casi todas las primeras conversaciones: nadie me ha explicado esto de verdad.",
        "La Sesión del Comprador Estratégico es una hora de explicación directa sobre cómo funcionan, en general, los préstamos FHA y convencionales, qué documentación importa y qué preguntas hacer. Sin promesas de tasas ni de aprobaciones. Solo la información que usted merece antes de hablar con alguien sobre un préstamo.",
      ],
      creds: [
        { l: "COMPANY", v: PH.company, ph: false },
        { l: "NMLS#", v: PH.nmls, ph: false },
        { l: "CO. NMLS#", v: PH.companyNmls, ph: false },
        { l: "LICENSED IN", v: PH.licenseStates, ph: false },
      ],
    },
    empathy: {
      label: "",
      h2: "Si usted es como la mayoría de los compradores con los que trabajo...",
      pains: [
        "Probablemente usted se ha sentado frente a alguien que citó números que no podía verificar y le preguntó cuándo estaría listo para avanzar — rápido, en inglés, lleno de siglas que nadie define. Eso no es una estrategia. Es lanzar una moneda con la compra más grande de su vida.",
      ],
      changesLabel: "ESTO ES LO QUE CAMBIA DESPUÉS DE ESTA SESIÓN:",
      transforms: [
        "Entenderá qué programas de préstamo se ajustan de forma realista a su situación",
        "Sabrá exactamente qué documentación reunir antes de solicitar su préstamo",
        "Tendrá un siguiente paso claro, en su propio idioma, sin obligación de continuar",
      ],
    },
    takeaways: {
      label: "",
      h2: "QUÉ SE LLEVARÁ DE LA SESIÓN",
      cards: [
        { i: "🗺️", t: "Visión más clara", d: "Una imagen realista de los caminos del préstamo FHA y el préstamo convencional disponibles para compradores de vivienda por primera vez." },
        { i: "✅", t: "Lista de preparación", d: "Exactamente qué documentos reunir para que nada lo tome por sorpresa." },
        { i: "💬", t: "Preguntas para hacer", d: "Las preguntas que revelan si un prestamista está explicando — o solo vendiendo." },
        { i: "📋", t: "Siguiente paso opcional", d: "Un camino sin presión hacia una conversación 1-a-1 con Plinio, solo si usted lo desea." },
      ],
      testimonialNote: "[VERIFIED TESTIMONIAL — REPLACE WITH REAL REVIEW]",
    },
    faq: {
      label: "",
      h2: "PREGUNTAS FRECUENTES",
      items: [
        { q: "¿La sesión es gratis?", a: "Sí — completamente gratis. Es un evento educativo para compradores de vivienda por primera vez. No hay tarifa, no hay compra, y no hay nada que comprar al final." },
        { q: "¿Esto es una solicitud de préstamo?", a: "No. Asistir no es una solicitud de préstamo y no crea ninguna obligación. Es un recorrido educativo por las consideraciones del préstamo FHA y el préstamo convencional para compradores de vivienda por primera vez." },
        { q: "¿Asistir afectará mi crédito?", a: "No. Registrarse y asistir no implica ninguna consulta de crédito — ni dura ni suave. Usted simplemente estará viendo una sesión educativa." },
        { q: "¿Para quién es esta sesión?", a: "Compradores de vivienda por primera vez — especialmente hispanohablantes en NY, NJ, CT, PA y FL — que desean que les expliquen con claridad el préstamo FHA y el préstamo convencional antes de comprometerse con nada." },
        { q: "¿Qué se cubrirá?", a: "Cinco módulos: entender dónde está, qué preparar, explorar el préstamo FHA y el préstamo convencional en lenguaje sencillo, evitar errores comunes, y salir con un siguiente paso claro." },
        { q: "¿Es en vivo o grabada?", a: "Es una sesión en vivo con preguntas en vivo, así que usted puede hacer sus propias preguntas. Regístrese y recibirá la fecha, hora y detalles de acceso por correo." },
        { q: "¿Qué pasa después de registrarme?", a: "Recibirá una confirmación por correo con los detalles de la sesión. Antes de la sesión recibirá los materiales de preparación. Eso es todo — sin llamadas a menos que usted las pida." },
        { q: "¿Tengo que hablar con un oficial de préstamos?", a: "No. La conversación 1-a-1 de seguimiento con Plinio es completamente opcional. Puede asistir, aprender y decidir a su propio ritmo sin ninguna obligación." },
      ],
    },
    final: {
      label: "",
      h2a: "SU PRÓXIMO PASO EMPIEZA CON UN MAPA MÁS ",
      h2b: "CLARO.",
      bullets: [
        "Sesión educativa 100% gratis — sin costo, nunca",
        "No se requiere consulta de crédito para asistir",
        "Explicado en un lenguaje claro, en inglés y en español",
        "Sin obligación de solicitar, continuar ni hablar con nadie",
      ],
    },
    footer: {
      contact: ["📞 +1 (973) 901-2586", "✉️ pa.group@outlook.com", "🌐 webinar.plinioangulo.com"],
      legalLinks: [{ t: "Política de Privacidad", to: "/privacy" }, { t: "Términos y condiciones", to: "/terms" }],
      compliance: "[[APROBACIÓN DE CUMPLIMIENTO PENDIENTE — texto final sujeto a aprobación del brokerage]]",
      complianceDraft: "Borrador propuesto: \u201CEsta es una sesión educativa. La asistencia no constituye una solicitud de préstamo. No se requiere consulta de crédito. Los resultados no están garantizados. Plinio Angulo NMLS #1443167, Guaranteed Rate Inc. DBA Rate NMLS #2611.\u201D",
      copyright: "© 2026 Guaranteed Rate Inc. DBA Rate",
    },
  },
};
